import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "reporting" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "type-data-mini" }
const _hoisted_9 = { class: "first-column-with-icon-type" }
const _hoisted_10 = { class: "name-type-block" }
const _hoisted_11 = { class: "name-data" }
const _hoisted_12 = { class: "type-data-mini" }
const _hoisted_13 = { class: "emq-table-footer" }

import { getInvoiceApplyItems } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Download } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { dateFormat, throttleBtn } from '@/common/tools'
import SelectOperator from '@/components/SelectOperator.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import AuditApplyItem from './components/AuditApplyItem.vue'


import { defineComponent, onActivated, onMounted, ref, Ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const __default__ = defineComponent({
  name: 'Evses',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Operation')

const showDialog = ref(false)
const showItem = ref({})

const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { getCommonStateDesc, commonStates } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const editApplyItem = (row: any) => {
  showDialog.value = true
  showItem.value = row
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { operatorId, userId, state, applyId } = params
  newParams = {
    operatorId: operatorId || undefined,
    userId: userId || undefined,
    state: state || undefined,
    applyId: applyId || undefined,
  }
  return newParams
}

onActivated(() => {
  const { query } = useRoute()
  if (query.id) {
    fuzzyParams.value.applyId = query.id
  }
  handleSearch()
})

const loadDatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getInvoiceApplyItems(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas)

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.state,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.state) = $event)),
                  placeholder: _ctx.$t('Evses.state'),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonStates), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.applyId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.applyId) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: _ctx.$t('Operation.applyId')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_tooltip, {
                  content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "icon-button",
                      plain: "",
                      icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            width: "250",
            fixed: "",
            label: _ctx.$t('Base.id'),
            "header-align": "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.id), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Operation.applyId')) + " : " + _toDisplayString(row.applyId), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Operation.operator'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(LinkOperator, {
                      id: row.evseOperatorId,
                      name: row.evseOperatorName
                    }, null, 8, ["id", "name"])
                  ]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(LinkOperator, {
                      id: row.operatorId,
                      name: row.operatorName
                    }, null, 8, ["id", "name"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "titleName",
            width: "200",
            label: _ctx.$t('Operation.buyerName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "invoiceAmount",
            label: _ctx.$t('Operation.invoiceAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            label: _ctx.$t('Base.status')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getCommonStateDesc)(row.state)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            label: _ctx.$t('Base.updatedAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.updatedAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation",
            width: "150"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editApplyItem(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Operation.auditInvoice')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'auditApplyItem']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(AuditApplyItem, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
      itemInfo: showItem.value,
      onSubmitted: loadDatas
    }, null, 8, ["modelValue", "itemInfo"])
  ]))
}
}

})